<template>
  <span :class="{ 'dice': true, [dieType]: true, 'isRolled': typeof roll === 'number' }">
    <span v-if="!empty" class="diceLabel">{{ typeof roll === 'number' ? roll : die }}</span>
  </span>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    die: {
      type: String,
      required: true
    },

    roll: {
      type: Number
    },

    empty: {
      type: Boolean
    }
  },

  setup (props) {
    const dieType = computed(() => `isD${props.die.split('d')[1]}`)

    return {
      dieType
    }
  }
})
</script>

<style lang="sass" scoped>
.dice
  position: relative
  width: 4em
  display: inline-flex
  align-items: center
  background-size: contain
  background-repeat: no-repeat
  background-position: center

  &.isD4
    background-image: url('../../public/images/dice/d4.svg')
    width: 3.6em
    height: 3.2em
    &.isRolled
      background-image: url('../../public/images/dice/rolled/d4.svg')

  &.isD6
    background-image: url('../../public/images/dice/d6.svg')
    width: 3.6em
    height: 3.6em
    &.isRolled
      background-image: url('../../public/images/dice/rolled/d6.svg')

  &.isD8
    background-image: url('../../public/images/dice/d8.svg')
    width: 3.5em
    height: 4.4em
    &.isRolled
      background-image: url('../../public/images/dice/rolled/d8.svg')

  &.isD10,
  &.isD100
    background-image: url('../../public/images/dice/d10.svg')
    width: 4em
    height: 4em
    &.isRolled
      background-image: url('../../public/images/dice/rolled/d10.svg')

  &.isD12
    background-image: url('../../public/images/dice/d12.svg')
    width: 4.2em
    height: 4.4em
    &.isRolled
      background-image: url('../../public/images/dice/rolled/d12.svg')

  &.isD20
    background-image: url('../../public/images/dice/d20.svg')
    width: 3.9em
    height: 4.4em
    &.isRolled
      background-image: url('../../public/images/dice/rolled/d20.svg')

.diceLabel
  margin: auto
  font-weight: bold
  border-radius: 100px
  display: inline-flex
  color: #000
  text-align: center

.dice.isRolled .diceLabel
  color: var(--primary)
  box-shadow: none
</style>